import React, { useState, useEffect } from "react";
import { useNavigate} from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const CTA = () => {

  const eventTypes = [
    "Corporate Events",
    "Seminars",
    "Conferences",
    "Award Shows",
    "Workshops",
    "Weddings",
    "Concerts"
  ];
  const sendEmail = (e) => {
    e.preventDefault();
  
    const formData = new FormData(e.target);
    const data = {
      from_firstname: formData.get("from_firstname"),
      from_lastname: formData.get("from_lastname"),
      from_phonenumber: formData.get("from_phonenumber"),
      country: formData.get("country"),
      from_emailid: formData.get("from_emailid"),
      organization: formData.get("organization"),
      message: formData.get("message"),
    };
  
    console.log("Data being sent:", data);
  
    emailjs
      .send("service_nxepswl", "template_jumzlyr", data, "Ei4GRgZo9kOlQvyW9")
      .then((response) => {
        console.log("Email sent successfully", response);
        alert("Your message has been sent successfully!");
      })
      .catch((error) => {
        console.error("Email sending failed", error);
        alert("Sorry, something went wrong. Please try again later.");
      });
  };
  
  const [isOpen, setIsOpen] = useState(false);
  
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      await sendEmail(event);
      togglePopup();
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  
  const handleLogin = () => {
    navigate("/login");
    window.history.go(-1);
  };
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % eventTypes.length);
    }, 2000); // Change word every 2 seconds
    return () => clearInterval(interval);
  }, []);


  return (
    
      
      <div className="cta-section">
 <h2>
  Make sustainability part of your{" "}
  <span className="rotating-wrapper">
    <span className="rotating-text">{eventTypes[currentIndex]}</span>
  </span>
</h2>

      <p>
        Start Tracking Carbon Emission with <strong>EcoIndex</strong>
      </p>
  <div className="cta-buttons">
  <button style={{ '--clr': '#7808d0' }} className="button-start" onClick={handleLogin}>
              <span className="button__icon-wrapper">
                <svg
                  width="10"
                  className="button__icon-svg"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
                <svg
                  className="button__icon-svg button__icon-svg--copy"
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  fill="none"
                  viewBox="0 0 14 15"
                >
                  <path
                    fill="currentColor"
                    d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  ></path>
                </svg>
              </span>
              Get Started for FREE
            </button>
            
            <button className="demo" onClick={togglePopup}>Request for Demo <FaPhoneAlt /> </button>

            
{isOpen && (
                <div className="popup">
                  <div className="popup-content">
                    <span className="close-icon" onClick={togglePopup}>
                      &times;
                    </span>
                    <h2 className="popup-title">
                      Schedule a Call <i class="fa fa-phone"></i>
                    </h2>

                    <form className="popup-form" onSubmit={handleFormSubmit}>
                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>First Name</label>
                          <input type="text" name="from_firstname" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Last Name</label>
                          <input type="text" name="from_lastname" required />
                        </div>
                      </div>

                      <div className="input-row">
                        <div className="input-group half-width">
                          <label>Phone No.</label>
                          <input type="tel" name="from_phonenumber" required />
                        </div>
                        <div className="input-group half-width">
                          <label>Country</label>
                          <input type="text" name="country" required />
                        </div>
                      </div>

                      <div className="input-group">
                        <label>Email</label>
                        <input type="email" name="from_emailid" required />
                      </div>

                      <div className="input-group">
                        <label>Organization</label>
                        <input type="text" name="organization" required />
                      </div>

                      <div className="input-group">
                        <label>What do you want to know?</label>
                        <textarea name="message" required></textarea>
                      </div>

                      <div className="popup-buttons">
                        <button type="submit" className="submit-button">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

  </div>
</div>

  )
}

export default CTA
